import { lang } from "../stored";
import { save } from "../storage";
import {
  STORE_KEY_CONFIG_LANG
} from "../constants";
import { settings, shipments } from "../resources.js";

const state = {
  lang: lang,
  // value see http://stackoverflow.com/questions/5580876/navigator-language-list-of-all-languages
  langs: [
    {
      label: "Български",
      value: "bg"
    },
    {
      label: "English",
      value: "en"
    }
  ],
  countries: [],
  countriesLoading: false,
  settings: {}
};

const mutations = {
  UPDATE_LANG(state, lang) {
    state.lang = lang || state.lang;
  },
  UPDATE_COUNTRIES(state, countries) {
    state.countries = countries || [];
  },
  UPDATE_SETTINGS(state, settings) {
    state.settings = settings || {};
  }
};

const actions = {
  changeLang({ commit }, lang) {
    commit("UPDATE_LANG", lang);
    save(STORE_KEY_CONFIG_LANG, lang);
  },
  loadCountries({ commit, state }) {
    if (state.countriesLoading || (state.countries && state.countries.length)) {
      return;
    }
    state.countriesLoading = true;

    let results = [];

    shipments.countries().then(res => {
      // console.log('loadCountries', res.body);
      if (res.body) {
        results = res.body;
      }
    }).catch(err => {
      console.log('Error loading catalog countries');
    }).finally(() => {
      commit("UPDATE_COUNTRIES",
        [
          { id: '1', code: 'BG', bg: 'България', en: 'Bulgaria', rules: [], is_visible: true, is_allowed_orders: true }
        ].concat( results )
        .map(elem => ({
          ...elem,
          is_visible:        elem.is_visible        !== null ? elem.is_visible        : true,
          is_allowed_orders: elem.is_allowed_orders !== null ? elem.is_allowed_orders : true,
        }))
      );
    });
  },
  async loadSettings({ commit }) {
    try {
      const response = await settings.load();
      const data = await response.json();
      commit("UPDATE_SETTINGS", data);
      return data;
    } catch(err) {
      throw err;
    };
  }
};

const getters = {
  globalConfig(state) {
    return state;
  },
  countries(state) {
    return state.countries
      ? state.countries.map(elem => ({
          ...elem,
          text: elem[ state.lang ]
      }))
      : [];
  },
  countriesVisible(state, getters) {
    return getters.countries.filter(elem => elem.is_visible)
  },
  settings(state) {
    return state.settings;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};